// extracted by mini-css-extract-plugin
export default {"slide":"---------packages-corgi-x-src-components-MultipleItemsSlideshow-Slide-module__slide"};